export const modules = {
  toolbar: [
    [{ color: ["#2E3C4C", "#565A5E"] }],
    ["bold", "italic", "underline"],
    ["link", "image"],
    [{ size: ["small", false, "large"] }],
    [{ align: [] }],
    ["clean"],
    [{ list: "ordered" }, { list: "bullet" }],
  ],
};

export const formats = [
  "color",
  "size",
  "bold",
  "italic",
  "link",
  "image",
  "align",
  "list",
];

export const titleModules = {
  toolbar: [
    [{ color: ["#2E3C4C", "#565A5E"] }],
    ["bold", "italic", "underline"],
    [{ size: ["small", false, "large"] }],
    ["clean"],
    ["list"],
  ],
};

export const titleFormats = ["color", "size", "bold", "italic"];

export const noImagePlaceholder =
  "https://t4.ftcdn.net/jpg/04/73/25/49/360_F_473254957_bxG9yf4ly7OBO5I0O5KABlN930GwaMQz.jpg";



// WEBPACK FOOTER //
// ./src/constants/baseConst.js